<div class="add-container">
    <h1 class="add-title">Adaugă o cerere</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row p-1">
            <div class="col">
                <mat-form-field>
                    <mat-label>Subiect</mat-label>
                    <input matInput type="text" formControlName="subject">
                </mat-form-field>
            </div>
        </div>
        <div class="row p-1">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Prioritate</mat-label>
                    <mat-select formControlName="id_cerere_priority">
                        <mat-option *ngFor="let row of requestPriorities" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row p-1">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Departament</mat-label>
                    <mat-select formControlName="id_departament">
                        <mat-option *ngFor="let row of departament" [value]="row.id">
                            {{ row.name }}
                        </mat-option>
                        </mat-select>
                        </mat-form-field>
                        </div>
                        </div>
                        <div class="row p-1">
                            <div class="col">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Tip Cerere</mat-label>
                                    <mat-select formControlName="id_cerere_type">
                                        <mat-option *ngFor="let row of cerereType" [value]="row.id">
                                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row p-1">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Responsabil</mat-label>
                    <mat-select formControlName="id_user_assigned">
                        <mat-option>
                            --Alegeți--
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row p-1">
            <div class="col">
                <div class="fw-bold">Descriere</div>
                <angular-editor formControlName="description" [config]="editorConfig"></angular-editor>
            </div>
        </div>


        <div class="solicitare-card__upload">
            <div class="solicitare-card__upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInput.click()" type="button">
                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="solicitare-card__upload-files" *ngIf="
                                                                                                                                                  form.value.files.length > 0 &&
                                                                                                                                                  !uploading.file
            ">
                <div class="solicitare-card__upload-file" *ngFor="
                                    let uploadedFile of form.value.files;
                                    let i = index
              ">
                    <span class="solicitare-card__upload-file-name">
                        {{
                        uploadedFile.original_name.length > 30
                        ? (uploadedFile.original_name | slice : 0 : 30) +
                        ".."
                        : uploadedFile.original_name
                        }}
                    </span>
                    <div>
                        <button class="solicitare-card__upload-file-delete" type="button"
                            matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                id="upload-file-input-0" #fileInput name="fileInput"
                (change)="addFile($event, 'file')" multiple style="display: none" />
        </div>

        <div class="row mt-2">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
        <div class="section-spinner position-absolute" *ngIf="isLoading" style="background: rgba(0, 0, 0, 0.6);">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">
                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                </h3>
                </div>
                </div>
    </form>
    </div>